import { ProgressHTMLAttributes } from 'react'

import { ProgressStyles } from '~/shared/components/Progress/styles'

export interface Props extends ProgressHTMLAttributes<HTMLProgressElement> {
  color?: string
  $valueBorderRadius?: string
  $background?: string
  $roundedAllSides?: boolean
}

export const Progress = (props: Props) => <ProgressStyles {...props} />
